import { initVueDeliverySchedule } from "./deliverySchedule";
import { editStepHandler } from "../stepsCT";
import { scrollToElement } from "../../utilities/scrollToElement";
import { SCROLL_TIMER_1S, TIMER_3S } from "../../utilities/constants";
import { waitForEl } from "../../utilities/globalUtilities";
import { setCookie, getCookie } from "../../components/cookie";

const $cache = {
    mainContent: $(".checkout-steps--wrapper")
};

/**
 * Handles lazy load of delivery slots for shipments once checkout page loaded
 */
const initializeDeliverySchedule = () => {
    const shippingDeliverySlots = document.querySelectorAll(".shipping-delivery-slot");
    const entregaZeroSection = document.querySelector(".js-delivery-slot-entrega-zero");
    if (entregaZeroSection) {
        const isEntregaZeroNotInDefaultShipment = entregaZeroSection.dataset.isEntregaZeroNotInDefaultShipment;
        if (isEntregaZeroNotInDefaultShipment == "true") {
            bookDeliverySlotForEntregaZero();
        } else {
            var isDeliverySlotBookedForE0 = entregaZeroSection.dataset.isDeliverySlotBooked;

            if (!isDeliverySlotBookedForE0 || isDeliverySlotBookedForE0 != "true") {
                $("#service-error-entrega-zero").modal("show");
                document.querySelector(".submit-shipping").disabled = true;

                return;
            }
        }
    }

    $cache.mainContent.spinner().start();

    shippingDeliverySlots.forEach(slot => {
        getDeliverySchedule(slot);
    });

    const multiShippingModal = $("#multi-shipping-modal");
    if (multiShippingModal && shippingDeliverySlots && shippingDeliverySlots.length > 1) {
        const isMultiShippingModalShown = getCookie("shownMultiShippingModal");

        if (!isMultiShippingModalShown) {
            multiShippingModal.modal("show");
            setCookie("shownMultiShippingModal", "true");
        }
    }

    $cache.mainContent.spinner().stop();
};

/**
 * Book delivery slot for entrega zero when is not part of the default shipment - this is for the case when the user has a grocery shipment and that becomes prio before E0 in shipments reorder
 */
const bookDeliverySlotForEntregaZero = () => {
    var url = $(".js-book-delivery-slot-for-entrega-zero").attr("data-url");

    if (url) {
        $.spinner().start();

        $.ajax({
            url: url,
            type: "POST",
            dataType: "JSON",
            success: response => {
                if (response && !response.error && response.isEntregaZeroSlotBooked) {
                    const entregaZeroSection = document.querySelector(".js-delivery-slot-entrega-zero");
                    entregaZeroSection.dataset.isDeliverySlotBooked = true;
                } else {
                    $("#service-error-entrega-zero").modal("show");
                    document.querySelector(".submit-shipping").disabled = true;
                }
            },
            complete: () => {
                $.spinner().stop();
            }
        });
    }
};

/**
 * Update the address after automatical delivery location change
 * @param {String} selectedShippingMethodId - The selected shipping method id
 */
const updateAddressAfterDeliveryLocationChange = (selectedShippingMethodId) => {
    $("body").on("hidden.bs.modal", "#current-shipping-method-not-supported", function (e) {
        const currentTarget = e.currentTarget;

        if (selectedShippingMethodId == 0) {
            const modalCloseBtn = currentTarget.querySelector(".js-shipping-method-not-supported-close");

            $.spinner().start();
            $.ajax({
                url: modalCloseBtn.dataset.isFirstOrderUrl,
                type: "POST",
                dataType: "JSON",
                success: response => {
                    if (response.success) {
                        if (!response.isFirstOrder) {
                            response.lastOrderShipments.forEach(elem => {
                                const previousOrderAddress = document.querySelector(`.js-type-address[data-address-id="${elem.shippingAddress.id}"] input`);

                                if (previousOrderAddress) {
                                    previousOrderAddress.checked = true;
                                    previousOrderAddress.dispatchEvent(new Event("click"));
                                }

                            });
                        } else {
                            const firstAddress = document.querySelector(".js-type-address input");
                            firstAddress.checked = true;
                            firstAddress.dispatchEvent(new Event("click"));
                        }
                    }
                },
                complete: () => {
                    $.spinner().stop();
                }
            });
        }
    });
};

const getDeliverySchedule = slot => {
    const { dataset } = slot;
    const { shipmentDeliverySlots, wasAddressAutomaticallyChanged, selectedShippingMethodId } = dataset;

    try {
        const $deliverySlotsServiceErrorModal = $("#service-error-delivery-slots");
        const $shippingMethodNotSupportedErrorModal = $("#current-shipping-method-not-supported");

        if (shipmentDeliverySlots && shipmentDeliverySlots.includes("{")) {
            if (wasAddressAutomaticallyChanged == "true") {
                $cache.mainContent.spinner().stop();
                setTimeout(() => {
                    $shippingMethodNotSupportedErrorModal.modal("show");

                    updateAddressAfterDeliveryLocationChange(selectedShippingMethodId);
                }, SCROLL_TIMER_1S);

                let $shippingContainer = $(".shipping-section .step-type--address");
                setTimeout(() => {
                    $shippingContainer.find(".js-step-body-resume").addClass("d-none");
                    $shippingContainer.find(".js-step-body-selection").removeClass("d-none");
                }, TIMER_3S);

                slot.setAttribute("data-was-address-automatically-changed", "false");

                //In case we change the client address, we will now show all the addresses but uncheck the selected address, so de client decides which delivery he wants to choose
                let defaultShippingAddress = document.querySelector(".step-type--address");
                let defaultShippingAddressChecked = defaultShippingAddress?.querySelector("[checked]");

                if (defaultShippingAddress && defaultShippingAddressChecked) {
                    defaultShippingAddressChecked.checked = false;
                    defaultShippingAddress.dataset.overridePreviousAddressSelection = "true";
                }

                return null;
            }

            const data = JSON.parse(shipmentDeliverySlots);
            const deliverySlotContainer = slot.querySelector(".js-delivery-slots-wrapper");

            if (!data || !data.shipmentDeliverySlots || data.shipmentDeliverySlots.length == 0) {
                $cache.mainContent.spinner().stop();
                setTimeout(() => {
                    $deliverySlotsServiceErrorModal.modal("show");
                }, SCROLL_TIMER_1S);

                //to reset shipmentDeliverySlots data, to not go into if condition
                slot.dataset.shipmentDeliverySlots = "";

                return null;
            }

            initVueDeliverySchedule(deliverySlotContainer, data);
            editStepHandler();
            $cache.mainContent.spinner().stop();
        } else {
            const { deliverySlotUrl, shipmentId } = dataset;
            const url = `${deliverySlotUrl}?shipmentId=${shipmentId}`;
            let $shippingContainer = $(`.shipping-section .step-type--address[data-shipment-id="${shipmentId}"]`);
            $cache.mainContent.spinner().start();

            if (wasAddressAutomaticallyChanged == "true") {
                $cache.mainContent.spinner().stop();
                let indexShipmentString = shipmentId.lastIndexOf("0");
                let shipmentNumber = shipmentId.slice(indexShipmentString + 1);
                setTimeout(() => {
                    $shippingMethodNotSupportedErrorModal.modal("show");
                    $shippingMethodNotSupportedErrorModal.on("shown.bs.modal", () => {
                        waitForEl("#current-shipping-method-not-supported .ct-error-modal-general--msg", function () {
                            const modalMessage = $shippingMethodNotSupportedErrorModal.find(".ct-error-modal-general--msg");
                            const newMessage = `<span class="font-weight-bold">${shipmentNumber}</span>`;
                            const regex = /<span class="font-weight-bold">\d+<\/span>/g;

                            if (modalMessage.data("flagged") && regex.test(modalMessage.html())) {
                                const currentDeliveries = modalMessage.html().match(regex);
                                // Format the list with "e" before the last number
                                const formattedDeliveries =
                                    currentDeliveries.length > 1
                                        ? currentDeliveries.slice(0, -1).join(", ") + " e " + currentDeliveries[currentDeliveries.length - 1]
                                        : currentDeliveries[0];

                                // Add the newMessage to the formatted list
                                const updatedDeliveries = formattedDeliveries + " e " + newMessage;

                                modalMessage.html(
                                    `Neste momento não é possível recolher em loja um ou mais produtos da sua encomenda. A <span class="font-weight-bold">entrega</span> ${updatedDeliveries} foi alterada para entrega em casa. Por favor, selecione uma morada.`
                                );
                            } else {
                                modalMessage.html(
                                    `Neste momento não é possível recolher em loja um ou mais produtos da sua encomenda. A <span class="font-weight-bold">entrega</span> ${newMessage} foi alterada para entrega em casa. Por favor, selecione uma morada.`
                                );
                                modalMessage.data("flagged", true);
                            }

                        });
                    });

                }, SCROLL_TIMER_1S);

                setTimeout(() => {
                    $shippingContainer.find(".js-step-body-resume").addClass("d-none");
                    $shippingContainer.find(".js-step-body-selection").removeClass("d-none");
                }, TIMER_3S);

                slot.setAttribute("data-was-address-automatically-changed", "false");

                //In case we change the client address, we will now show all the addresses but uncheck the selected address, so de client decides which delivery he wants to choose
                let defaultShippingAddress = document.querySelector(`.step-type--address[data-shipment-id="${shipmentId}"]`);
                let defaultShippingAddressChecked = defaultShippingAddress?.querySelector("[checked]");

                if (defaultShippingAddress && defaultShippingAddressChecked) {
                    defaultShippingAddressChecked.checked = false;
                }

                return null;
            }

            $.ajax({
                url: url,
                type: "GET",
                success: response => {
                    var isResponseSuccess = !response.error && response.shipmentDeliverySlots && response.shipmentDeliverySlots.groupedDeliverySlots && response.shipmentDeliverySlots.groupedDeliverySlots.length > 0;
                    if (isResponseSuccess) {
                        let deliverySlotContainer = slot.querySelector(".js-delivery-slots-wrapper");
                        if (!deliverySlotContainer) {
                            slot.innerHTML = "<div class=\"js-delivery-slots-wrapper\"></div>";
                            deliverySlotContainer = slot.querySelector(".js-delivery-slots-wrapper");
                        }

                        initVueDeliverySchedule(deliverySlotContainer, response);
                        editStepHandler();
                        $cache.mainContent.spinner().stop();
                    } else {
                        $cache.mainContent.spinner().stop();
                        scrollToElement($(`.js-step-wrapper[data-shipment-id="${shipmentId}"]`).closest(".shipping-step--wrapper"), SCROLL_TIMER_1S);

                        setTimeout(() => {
                            $deliverySlotsServiceErrorModal.modal("show");
                        }, SCROLL_TIMER_1S);
                    }
                }
            });
        }
    } catch (error) {
        $cache.mainContent.spinner().stop();
        return null;
    }
};

const initDeliverySchedule = () => {
    initializeDeliverySchedule();
};

export {initDeliverySchedule, getDeliverySchedule};
